import Vue from 'vue';
import VueTheMask from 'vue-the-mask';
import ReactiveProvide from 'vue-reactive-provide';
import store from 'Arch/store';
import App from './App.vue';
import './plugins/global-components';
import i18n from './plugins/i18n';
import './plugins/sweetalert2';
import vuetify from './plugins/vuetify';
import router from './router';
import '@/plugins/product-zoomer';
import '@/plugins/cool-ligth-box';
import '@/plugins/image-cliper';
import '@/plugins/vue-reactive-provide';
import '@/plugins/google-maps';
import './sass/colors.sass';
import './sass/font.sass';
import './sass/theme.sass';
import './sass/utils.sass';
import './plugins/loading';
import './plugins/eventBus';

Vue.config.productionTip = false;
Vue.use(VueTheMask);
Vue.use(ReactiveProvide);

Vue.mixin({
  methods: {
    makeKey(key, ...props) {
      let name = `${key}_${Math.random() * 10}`;
      props.forEach(
        (prop) => {
          name += `_${prop}`;
        },
      );
      return name;
    },
    isBool(value) {
      return typeof value === 'boolean';
    },
  },
});

new Vue({
  router,
  vuetify,
  i18n,
  render: (h) => h(App),
  store,
}).$mount('#app');
